@if (encryptForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="encryptForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <clickatell-form-validation [controlName]="'name'"
            [form]="encryptForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="encryptForm" id="name"
              [formControlName]="'name'" placeholder="Enter name"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <clickatell-form-validation [controlName]="'description'"
              [form]="encryptForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="encryptForm" id="description"
                [formControlName]="'description'" placeholder="Enter description"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Algorithm </label>
                </div>
                <clickatell-form-validation [controlName]="'algorithm'"
                [form]="encryptForm"></clickatell-form-validation>
                <mat-select #algorithm [formControlName]="'algorithm'" class="control-dropdown"
                  (selectionChange)="algorithmChange(algorithm)" placeholder="Select algorithm" hideSingleSelectionIndicator>
                  @for (methode of algorithmGroup | keyvalue; track methode) {
                    <mat-optgroup [label]="methode.key">
                      @for (algorithm of algorithmGroup[methode.key] | keyvalue; track algorithm) {
                        <mat-option
                          [value]="algorithm.key">
                          {{ algorithm.value }}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
              </div>
              @if (algorithmsForm?.controls['method']?.value; as method) {
                <div>
                  @switch (method) {
                    @case ('encrypt') {
                      <ng-container [ngTemplateOutlet]="encrypt"></ng-container>
                    }
                    @case ('hash') {
                      <ng-container [ngTemplateOutlet]="hash"></ng-container>
                    }
                  }
                </div>
              }
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Variables </label>
                </div>
                <ng-container formArrayName="strings">
                  @for (stringsForm of encryptForm?.controls['strings']?.controls; track stringsForm; let i = $index) {
                    <div class="control-div"
                      >
                      <ng-container [formGroup]="stringsForm">
                        <clickatell-form-validation [controlName]="'value'"
                        [form]="stringsForm"></clickatell-form-validation>
                        <input class="control-input" activeForm [activeForm]="encryptForm" id="variables"
                          [formControlName]="'value'" placeholder="Enter variable"/>
                        </ng-container>
                      </div>
                    }
                  </ng-container>
                  <div class="control-div">
                    <div class="addBtnContainer">
                      <button class="addIcon" (click)="addVariable()">Add variable</button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Logic
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <ng-container [formGroup]="encryptForm">
                <div class="control-result">
                  <div class="control-result-header">
                    Yes
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'yes'"
                          [form]="encryptForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
                <div class="control-result">
                  <div class="control-result-header">
                    No
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'no'"
                          [form]="encryptForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }

      <ng-template #hash>
        <div class="control-div" [formGroup]="algorithmsForm">
          <div class="control-label-container">
            <label class="control-label"> Encoding </label>
          </div>
          <clickatell-form-validation [controlName]="'encoding'"
          [form]="algorithmsForm"></clickatell-form-validation>

          <mat-select [formControlName]="'encoding'" class="control-dropdown" id="encoding">
            @for (algorithm of algorithmGroup['encode'] | keyvalue; track algorithm) {
              <mat-option [value]="algorithm.key">
                {{ algorithm.value }}
              </mat-option>
            }
          </mat-select>
        </div>
      </ng-template>

      <ng-template #encrypt>
        <ng-container [formGroup]="algorithmsForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Compression </label>
            </div>
            <clickatell-form-validation [controlName]="'compression'"
            [form]="algorithmsForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="algorithmsForm" id="compression"
              [formControlName]="'compression'" placeholder="Enter compression"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Public Key </label>
              </div>
              <clickatell-form-validation [controlName]="'publicKey'"
              [form]="algorithmsForm"></clickatell-form-validation>
              <textarea class="control-textArea" activeForm [activeForm]="algorithmsForm" id="publicKey"
              [formControlName]="'publicKey'" placeholder="Enter public key"></textarea>
            </div>
          </ng-container>
        </ng-template>
